import React from 'react';

import { Button, Stack, Typography } from '@mui/material';
import { GridOverlay, useGridApiContext } from '@mui/x-data-grid-pro';

import { DEFAULT_FILTER_MODEL } from './utils';

export default function CompetitorOffersNoResults() {
  const apiRef = useGridApiContext();

  return (
    <GridOverlay>
      <Stack alignItems="center" spacing={1} p={3} textAlign="center">
        <Typography variant="subtitle1">No hotels match your filters</Typography>
        <Typography variant="body2" color="text.secondary">
          Try another hotel name, Flash ID or competitor.
        </Typography>
        <Button
          size="small"
          sx={{ pointerEvents: 'auto' }}
          onClick={() => apiRef.current.setFilterModel(DEFAULT_FILTER_MODEL)}
        >
          Clear filters
        </Button>
      </Stack>
    </GridOverlay>
  );
}
